// 二重submit防止
export function disableDoubleSubmit() {
  const submitButton = [].slice.call(document.getElementsByClassName('js-disable-double-submit'))
  if (submitButton.length === 0) return

  function toggleDisabled() {
    let disabledOffTimer: number

    submitButton.forEach((button: HTMLButtonElement) => {
      const form = button.closest('form')

      if (form === null) return

      // 戻るボタンで戻った時disabledのままにならないように
      button.disabled = false
      form.addEventListener('submit', () => {
        button.disabled = true

        // 以下の状況を回避するためにclearTimeoutを行う
        // submitボタン押下→バリデートエラー→ユーザがバリデートエラー解消→submitボタン押下→バリデートエラーにならない→setTimeoutが発動しsubmitボタンがdisabled→二重サブミットができる
        clearTimeout(disabledOffTimer)

        // ブラウザの中止ボタンを押した際にdisabledのままにならないように
        disabledOffTimer = window.setTimeout(() => {
          button.disabled = false
        }, 5000)
      })
    })
  }

  window.addEventListener('pageshow', () => {
    toggleDisabled()
  })
}
